export function removeBlanksFromObj<T>(obj: T): T {
  return JSON.parse(
    JSON.stringify(obj, (key, value) => {
      return value === null || value === undefined || value === "" ? undefined : value;
    })
  );
}
